import { Rocket, MessagesSquare, Sparkles } from "lucide-react";

const steps = [
  {
    n: "01",
    Icon: Rocket,
    title: "Launch a channel",
    body: "Create an always-on anonymous channel for any team in under 60 seconds. Share a link or QR code.",
    tone: "mkt-gradient-hero",
  },
  {
    n: "02",
    Icon: MessagesSquare,
    title: "Employees chat (not fill forms)",
    body: "AI Co-pilot interviews employees conversationally. Higher quality, 5× more responses than surveys.",
    tone: "mkt-gradient-purple",
  },
  {
    n: "03",
    Icon: Sparkles,
    title: "Get themes, sentiment, risk",
    body: "Themes cluster automatically. Sentiment is tracked over time. Retention risks surface before exits.",
    tone: "mkt-gradient-teal",
  },
];

export const HowItWorks = () => {
  return (
    <section className="container mx-auto px-3 lg:px-8 py-16 lg:py-24" id="how-it-works">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[hsl(var(--mkt-primary))] mb-3">
          How it works
        </div>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight">
          From Zero To Honest Feedback In 5 Minutes
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        {steps.map((s) => {
          const Icon = s.Icon;
          return (
            <div
              key={s.n}
              className="relative rounded-3xl bg-white border border-border mkt-shadow-card p-7 lg:p-8 flex flex-col"
            >
              <div className={`relative h-14 w-14 rounded-2xl ${s.tone} mkt-grain overflow-hidden inline-flex items-center justify-center text-white mb-5`}>
                <Icon className="h-6 w-6 relative" />
              </div>
              <div className="text-xs font-semibold tracking-[0.2em] text-muted-foreground">
                STEP {s.n}
              </div>
              <h3 className="mt-2 text-2xl font-bold text-foreground">{s.title}</h3>
              <p className="mt-3 text-muted-foreground leading-relaxed">{s.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};
